import script from "./top-bar-search-form.vue?vue&type=script&setup=true&lang=js"
export * from "./top-bar-search-form.vue?vue&type=script&setup=true&lang=js"

import "./top-bar-search-form.vue?vue&type=style&index=0&id=02b9b1d4&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b9b1d4"]])

export default __exports__